// eslint-disable-next-line no-useless-escape
const phoneRegex = new RegExp(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/);

export const isPhoneNumberFormat = data => phoneRegex.test(data);
export default {};
